export default class Highlights {
  constructor() {
    this.selector = '.js-highlights';
  }

  init() {
    this.render();
    window.addEventListener('resize', () => {
      this.reInit();
    });
  }

  render() {
    const self = this;
    $(() => {
      import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
        $(self.selector).each((key, item) => {
          const $item = $(item);
          $item.slick(self.constructor.sliderSettings());
        });
      });
    });
  }

  static sliderSettings() {
    return {
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  reInit() {
    const self = this;
    $(() => {
      import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
        $(self.selector).each((key, item) => {
          const $item = $(item);
          $item.slick('unslick').slick(self.constructor.sliderSettings());
        });
      });
    });
  }
}
